import { useCreateProposalFromProjectMapMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useCreateProposalFromProjectMap() {
  const [mutation, { data, loading, error }] = useCreateProposalFromProjectMapMutation();

  const [createProposalFromProjectMap, context] = useBitumioMutation(
    { mutation, data, loading, error, key: "createProposalFromProjectMap" },
    {
      successMessage: getLocalString("projectMaps.proposal-create-success"),
      failureMessage: getLocalString("projectMaps.proposal-create-failure"),
    }
  );

  return [createProposalFromProjectMap, context] as const;
}
